module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2/4-bac9ad61ce4895d869998a538e4b7988.png";